import styled, { css } from 'styled-components';
import { Link as DefaultLink } from 'react-router-dom';
import { DEVICES } from '_constants';
import { UiColors } from 'assets/styles/old/global';
import { deviceLess } from '_constants/DEVICES';

export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 1100; // to overlap map on edit retailer page and driving directions
  min-height: 54px;
  background-color: ${UiColors.forestColor};
  display: flex;
  align-items: center;
  padding: 0;

  img {
    margin-bottom: 2px;
  }
`;

export const LinkElem = styled(DefaultLink)`
  text-decoration: none;
  color: ${UiColors.forestColor};
  font-size: 14px;
  line-height: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: uppercase;

  &:focus {
    box-shadow: 0 0 0 2px var(--focus);
  }

  @media print {
    display: none !important;
  }

  @media ${deviceLess.header} {
    height: auto;
    justify-content: flex-start;
    color: ${UiColors.peachColor};
  }
  ${({ isLoginLink }) =>
    isLoginLink &&
    css`
      border-bottom: 2px solid ${UiColors.peachColor};
      height: calc(100% - 4px);
      margin-top: 2px;
      margin-right: 30px;
      @media ${DEVICES.tablet} {
        display: ${({ type }) => (type === 'logo' ? 'flex' : 'none')};
        margin: 0 16px 0 0;
      }
    `}
`;

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;
  padding: ${({ padding }) => padding || '0 20px'};
  @media ${DEVICES.tablet} {
    padding: 0;
    padding-right: 20px;
  }
  @media ${DEVICES.mobileXL} {
    padding-right: 10px;
  }
  :hover {
    cursor: pointer;
  }
`;

export const TooltipContainer = styled.div`
  display: none;
  opacity: 0;
  position: absolute;
  z-index: 1;
  background-color: #333;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 14px;
  transition: opacity 0.3s ease-in-out;
  top: 75%;
  right: -240px;
  transform: translateX(-100%);
`;

export const ToolTipSection = styled.div`
  display: flex;
  flex-direction: column;

  ${({ isSubDesc }) =>
    isSubDesc &&
    css`
      margin-top: 10px;
    `}

  p {
    display: inline-block;
    max-width: 400px;
    width: max-content;
    text-align: left;

    &:not(:last-child) {
      padding-bottom: 10px;
    }
  }
`;

export const TooltipContent = styled.div`
  display: inline-block;
  white-space: normal;
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover ${TooltipContainer} {
    display: inline-block;
    opacity: 1;
  }
`;

export const InfoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;

  @media ${DEVICES.tablet} {
    padding: 0;
    padding-right: 20px;
  }
  :hover {
    cursor: pointer;
  }
`;

export const Counter = styled.div`
  position: absolute;
  bottom: 45%;
  left: 45%;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: ${UiColors.mangoColor};
  color: ${UiColors.forestColor};
  text-align: center;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const AccountProduct = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  text-transform: uppercase;
  font-size: 14px;
  margin-top: 1px;
  font-weight: 500;
  color: var(--white);
  line-height: 16px;
  height: 100%;
  min-width: fit-content;
  max-width: 100px;
`;
